import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const NavLink = ({
  text,
  linkText,
  onClick
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, "modal-element-row") }, /* @__PURE__ */ React.createElement("span", { className: styles.text }, text), /* @__PURE__ */ React.createElement("button", { className: styles.button, onClick, type: "button" }, linkText));
NavLink.displayName = "Auth.Form.NavLink";

export { NavLink };
//# sourceMappingURL=index.js.map
